module.exports = __webpack_public_path__ + "static/media/attachments-new.9d2e5fa1.svg";